import * as yup from "yup";

const today = new Date();

const SignupSchema = yup.object().shape({
    firstName: yup.string().required("First name required"),
    lastName: yup.string().required("Last name required"),
    email: yup
        .string()
        .trim()
        .transform((val) => val?.toLowerCase())
        .email("Enter valid email")
        .required("Email required"),
    dob: yup
        .date()
        .typeError("Enter valid date")
        .min(new Date(1900, 1, 1), "Enter valid date")
        .max(
            new Date(
                today.getFullYear() - 13,
                today.getMonth(),
                today.getDate()
            ),
            "You must be 13 or older"
        )
        .required(),
    gender: yup.string().required("Gender is required"),
    password: yup
        .string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters"),
    passwordConfirmation: yup
        .string()
        .required("Password Confirmation is required")
        .oneOf([yup.ref("password"), null], "Passwords must match"),
    postalCode: yup
        .string()
        .required("Must provide postal code")
        .length(5, "ZIP must be 5 digits")
        .matches(/^\d+$/, "ZIP must only contain numbers"),
    userType: yup.string().required("Registration type is required"),
});

export default SignupSchema;
